const NomadMockup = () => (
  <svg viewBox='0 0 400 220' className='w-full h-full' role='img' aria-label='Nomad travel booking app mockup'>
    <defs>
      <linearGradient id='nomad-bg' x1='0' y1='0' x2='1' y2='1'>
        <stop offset='0%' stopColor='#0f2027' />
        <stop offset='50%' stopColor='#203a43' />
        <stop offset='100%' stopColor='#2c5364' />
      </linearGradient>
    </defs>
    <rect width='400' height='220' fill='url(#nomad-bg)' />

    <rect x='24' y='20' width='120' height='14' rx='4' fill='#fff' opacity='0.9' />
    <rect x='24' y='40' width='80' height='9' rx='3' fill='#fff' opacity='0.5' />
    <circle cx='368' cy='27' r='14' fill='#4db5ff' opacity='0.25' />
    <circle cx='368' cy='27' r='6' fill='#4db5ff' />

    <rect x='24' y='64' width='352' height='40' rx='10' fill='#ffffff' opacity='0.08' />
    <circle cx='44' cy='84' r='8' fill='#4db5ff' />
    <rect x='60' y='78' width='140' height='8' rx='3' fill='#fff' opacity='0.7' />
    <rect x='60' y='90' width='90' height='6' rx='3' fill='#fff' opacity='0.4' />
    <rect x='320' y='74' width='40' height='20' rx='6' fill='#4db5ff' />

    {[0, 1].map((i) => (
      <g key={i} transform={`translate(${24 + i * 182}, 118)`}>
        <rect width='170' height='82' rx='14' fill='#ffffff' opacity='0.07' />
        <rect x='12' y='12' width='70' height='36' rx='8' fill='#4db5ff' opacity='0.35' />
        <rect x='92' y='14' width='66' height='8' rx='3' fill='#fff' opacity='0.8' />
        <rect x='92' y='26' width='50' height='6' rx='3' fill='#fff' opacity='0.4' />
        <rect x='12' y='58' width='44' height='8' rx='3' fill='#4db5ff' opacity='0.9' />
        <rect x='120' y='58' width='38' height='16' rx='8' fill='#4db5ff' />
      </g>
    ))}
  </svg>
)

export default NomadMockup
